import { Controller } from '@hotwired/stimulus'

const validateEmail = (email: string) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.exec(
    email.toLowerCase(),
  )
}

export default class extends Controller {
  static targets = ['input', 'warning']

  declare readonly inputTarget: HTMLInputElement
  declare readonly warningTarget: HTMLElement

  initialize() {
    this.warningTarget.hidden = true
    this.inputTarget.addEventListener('input', this.onInputChange)
  }

  onInputChange = () => {
    const emailTest = this.inputTarget.value
    if (validateEmail(emailTest)) {
      const parts = emailTest.split('.')
      const tld = parts[parts.length - 1]

      if (tld === 'edu' || tld === 'org') {
        this.warningTarget.hidden = false
        this.warningTarget.classList.remove('hidden')
      } else {
        this.warningTarget.hidden = true
      }
    }
  }
}
